import React, {
    useMemo
} from 'react';
import {Row} from 'react-bootstrap';

import {Conditional} from "../../Conditional";
import {service as RelationshipService} from "../../../Services/RelationshipService";
import {service as StateService} from "../../../Services/StateService";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {sortByPropertyOrder} from "../../../Utils/sortByPropertyOrder";
import {ContactCard} from "./ContactCard";

export const ContactList = (props) => {
    
    const {
        projectStakeholderRelationships = [],
        limit = 2
    } = props;
    
    usePrimeCache([StateService, RelationshipService]);
    
    const landownerProjectId = RelationshipService.CachedValueByProperty('Landowner', 'name')?.result?.relationshipId;
    const projectManagerProjectId = RelationshipService.CachedValueByProperty('Project Manager', 'name')?.result?.relationshipId;
    
    const sortByRelationshipPriority = useMemo(() => {
        return sortByPropertyOrder(
            'relationshipId',
            [
                landownerProjectId,
                projectManagerProjectId
        ]);
    }, [landownerProjectId, projectManagerProjectId]);
    
    const sortedProjectStakeholderRelationships = useMemo(() => {
        if (!projectStakeholderRelationships) {
            return null;
        }
        return projectStakeholderRelationships
            .sort(sortByRelationshipPriority)
            .slice(0, limit);
    }, [projectStakeholderRelationships, sortByRelationshipPriority, limit]);
    
    if(!sortedProjectStakeholderRelationships) {
        return null;
    }
    
    return <Row className="sb-contact-list">
        {
            sortedProjectStakeholderRelationships.map((x) =>
                <ContactCard
                    key={x.projectStakeholderRelationshipId}
                    relationshipId={x.relationshipId}
                    stakeholderId={x.stakeholderId}
                />
            )
        }
    </Row>;
};